// import dayjs from '../lib/day.min.js'

export const formatTime = date => {
	const year = date.getFullYear()
	const month = date.getMonth() + 1
	const day = date.getDate()
	const hour = date.getHours()
	const minute = date.getMinutes()
	const second = date.getSeconds()

	return [year, month, day].map(formatNumber).join('/') + ' ' + [hour, minute, second].map(formatNumber).join(':')
}

export const formatNumber = n => {
	n = n.toString()
	return n[1] ? n : '0' + n
}
export const formatLocation = (longitude, latitude) => {
	if (typeof longitude === 'string' && typeof latitude === 'string') {
		longitude = parseFloat(longitude)
		latitude = parseFloat(latitude)
	}

	longitude = longitude.toFixed(2)
	latitude = latitude.toFixed(2)

	return {
		longitude: longitude.toString().split('.'),
		latitude: latitude.toString().split('.')
	}
}
//时间戳转时间格式
export const timeToDate = time => {
	var date = new Date(time * 1000); //如果date为13位不需要乘1000
	var Y = date.getFullYear() + '-';
	var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
	var D = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate()) + ' ';
	var h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
	var m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
	var s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
	return Y + M + D + h + m + s;
}
// const formatDatetimeS=date=>{
//   var m = moment( date|| new Date() );
//   return m.format('MM月DD日 HH:mm')
// }

//用户姓名汉字 2-10位
export const inputCheckChineseName = name => {
	if ((/^[\u4e00-\u9fa5]{2,10}$/.test(name))) {
		return true;
	}
	return false;
}

export const isCardCheck = card => {
	// 身份证号码为15位或者18位，15位时全为数字，18位前17位为数字，最后一位是校验位，可能为数字或字符X
	var reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
	if (reg.test(card)) {
		return true;
	}
	return false;
}

export function existy(variableName) {
	try {
		if (typeof(variableName) == "undefined") {
			return false;
		} else {
			return true;
		}
	} catch (e) {
		return false;
	}

}

export function isValid(value) {
	if (value === null || value == '') {
		return false;
	}
	return existy(value);
}

//验证手机号或固定电话
export function inputCheckPhone(val) {
	var regPos = /^\d+(\.\d+)?$/; //非负浮点数
	var regNeg = /^(-(([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*)))$/; //负浮点数
	if (regPos.test(val) || regNeg.test(val)) {
		return true;
	} else {
		return false;
	}
}
// function getDateMinute(time){
//     return dayjs(time).format("HH:mm")
// }
// function getCountDown(time){
//     var endTime=dayjs(time).add(30,'minute').unix();
//     var nowDate = dayjs().unix();
//     var diff=endTime-nowDate;
//     if(diff<=0) return '';
//     let minute = parseInt(diff/60);
//     let second = parseInt(diff%60);
//     return formatNumber(minute) + '分' + formatNumber(second)+'秒'
// }

//把obj对象里的值覆盖到newobj里面
export function deepCopy(newobj, obj) {
	if (typeof obj != 'object') {
		return obj;
	}
	for (var attr in obj) {
		var a = {};
		if (newobj[attr]) {
			a = newobj[attr];
		}
		newobj[attr] = deepCopy(a, obj[attr]);
	}
	return newobj;
}
export function getQueryString(name, url = window.location.serach) {
	var reg = new RegExp('(^|&|/?)' + name + '=([^&|/?]*)(&|/?|$)', 'i')
	var r = url.substr(1).match(reg)
	if (r != null) {
		return r[2]
	}
	return null;
}
//货币格式化
export function formatMoney(number, places, symbol, thousand, decimal) {
	number = number || 0;
	places = !isNaN(places = Math.abs(places)) ? places : 2;
	symbol = symbol !== undefined ? symbol : "￥";
	thousand = thousand || ",";
	decimal = decimal || ".";
	var negative = number < 0 ? "-" : "",
		i = parseInt(number = Math.abs(+number || 0).toFixed(places), 10) + "",
		j = (j = i.length) > 3 ? j % 3 : 0;
	return symbol + negative + (j ? i.substr(0, j) + thousand : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" +
		thousand) + (places ? decimal + Math.abs(number - i).toFixed(places).slice(2) : "");
}

/**
 * 金额相减
 * @param {Object} value1
 * @param {Object} value2
 */
export function moneySub(value1, value2) {
	let res = (parseFloat(value1) - parseFloat(value2)).toFixed(2);
	return res > 0 ? res : 0;
}

// 商品列表排列方式  1：多个一行 2：一个一行
export const goodsStyle = 1;

//保留两位小数 将浮点数四舍五入，强制取小数点后2位 
export function toDecimal2(x) {
	var f = parseFloat(x);
	if (isNaN(f)) {
		return false;
	}
	var f = Math.round(x * 100) / 100;
	var s = f.toString();
	var rs = s.indexOf('.');
	if (rs < 0) {
		rs = s.length;
		s += '.';
	}
	while (s.length <= rs + 2) {
		s += '0';
	}
	return s;
}
//字符串转整形，保留2位小数
export function toDecimal(x) {
	var f = parseFloat(x);
	if (isNaN(f)) {
		return;
	}
	f = Math.round(x * 100) / 100;
	return f;
}



export const checkPlate = () => {
	return navigator.userAgent.match(
		/(MIDP|WAP|UP.Browser|Smartphone|Obigo|Mobile|AU.Browser|wxd.Mms|WxdB.Browser|CLDC|UP.Link|KM.Browser|UCWEB|SEMC-Browser|Mini|Symbian|Palm|Nokia|Panasonic|MOT-|SonyEricsson|NEC-|Alcatel|Ericsson|BENQ|BenQ|Amoisonic|Amoi-|Capitel|PHILIPS|SAMSUNG|Lenovo|Mitsu|Motorola|SHARP|WAPPER|LG-|LG|EG900|CECT|Compal|kejian|Bird|BIRD|G900\/V1.0|Arima|CTL|TDG|Daxian|DAXIAN|DBTEL|Eastcom|EASTCOM|PANTECH|Dopod|Haier|HAIER|KONKA|KEJIAN|LENOVO|Soutec|SOUTEC|SAGEM|SEC-|SED-|EMOL-|INNO55|ZTE|iPhone|Android|Windows CE|Wget|Java|curl|Opera|phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
	)
}

export const redicectCheck = (v, parent) => {
	let flag = navigator.userAgent.match(
		/(MIDP|WAP|UP.Browser|Smartphone|Obigo|Mobile|AU.Browser|wxd.Mms|WxdB.Browser|CLDC|UP.Link|KM.Browser|UCWEB|SEMC-Browser|Mini|Symbian|Palm|Nokia|Panasonic|MOT-|SonyEricsson|NEC-|Alcatel|Ericsson|BENQ|BenQ|Amoisonic|Amoi-|Capitel|PHILIPS|SAMSUNG|Lenovo|Mitsu|Motorola|SHARP|WAPPER|LG-|LG|EG900|CECT|Compal|kejian|Bird|BIRD|G900\/V1.0|Arima|CTL|TDG|Daxian|DAXIAN|DBTEL|Eastcom|EASTCOM|PANTECH|Dopod|Haier|HAIER|KONKA|KEJIAN|LENOVO|Soutec|SOUTEC|SAGEM|SEC-|SED-|EMOL-|INNO55|ZTE|iPhone|Android|Windows CE|Wget|Java|curl|Opera|phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
	)
	//console.log(window.location)
	let url = window.location.pathname + '' + window.location.search;
	url = url.toLowerCase();

	let transform = [
		{
			wapUrl: "/wap/pagelogin/login/index1?invitecode=",
			pcUrl: "/web/?invitecode="
		},
		{
			wapUrl: "/wap/pages/goods/index/index?id=",
			pcUrl: "/web/detail/"
		},
		{
			wapUrl: "/wap/pageauction/index/index?id=",
			pcUrl: "/web/auction/"
		},
		{
			wapUrl: "/wap/pageactivity/article/index?",
			pcUrl: "/web/help?"
		},
		{
			wapUrl: "/wap/pages/cart/index/auciton",
			pcUrl: "/web/center/auctioncenter"
		},
		{
			wapUrl: "/wap/pagemember/order/orderdetail?order_id=",
			pcUrl: "/web/center/orderDetail/"
		},
		{
			wapUrl: "/wap/pageauction/index/list",
			pcUrl: "/web/auctionlist"
		},
		{
			wapUrl:"/wap/pageactivity/invite/index",
			pcUrl:"/web/center/invite"
		},
		{
			wapUrl:"/wap/pages/me/index",
			pcUrl:"/web/center/user"
		}
	];

	for (let key in transform) {
		let mobile = flag;
		
		transform[key].wapUrl = transform[key].wapUrl.toLowerCase();
		transform[key].pcUrl = transform[key].pcUrl.toLowerCase();
		let wapPattern = transform[key].wapUrl;
		var wapIndex = url.indexOf(transform[key].wapUrl);
		var pcIndex = url.indexOf(transform[key].pcUrl);
		let wapId = url.replace(transform[key].wapUrl, '');
		let pcId = url.replace(transform[key].pcUrl, '');

		if (!mobile && typeof(mobile) != "undefined" && mobile != 0) { //当前PC端
		
			if (window.location.pathname == '/wap/') {
				const targetUrl = '/web/';
				if (isSafeRedirect(targetUrl)) {
					window.location.href = targetUrl;
				}
				return false;
			}
			
			if (pcIndex == -1 && wapIndex > -1) {
				let targetUrl = '';
				if(wapId.indexOf('unsubscribe')){
					wapId = wapId.replace("&", "?");
					targetUrl = transform[key].pcUrl + wapId;
				}else{
					targetUrl = transform[key].pcUrl + wapId;
				}
				if (isSafeRedirect(targetUrl)) {
					window.location.href = targetUrl;
				}
				return false;
			}
		} else { //当前H5端
			if (window.location.pathname == '/web/') {
				const targetUrl = '/wap/';
				if (isSafeRedirect(targetUrl)) {
					window.location.href = targetUrl;
				}
				return false;
			}
			if (pcIndex > -1 && wapIndex == -1) {
				let targetUrl = '';
				if(pcId.indexOf('unsubscribe')){
					if(transform[key].pcUrl == '/web/auctionlist') {
						pcId = pcId.replace('id=', 'cat_id=');
					}else{
						pcId = pcId.replace("?", "&");
					}
					targetUrl = transform[key].wapUrl + pcId;
				}else{
					targetUrl = transform[key].wapUrl + pcId;
				}
				if (isSafeRedirect(targetUrl)) {
					window.location.href = targetUrl;
				}
				return false;
			}
		}
	}
	return true;
}

// 跳转域名白名单配置（限制：meituan.com、sankuai.com 及其子域名）
export const ALLOWED_DOMAINS = [
	'meituan.com',
	'meituan.net',
	'sankuai.com',
	'localhost'
];

/**
 * 校验 URL 是否属于安全的重定向白名单
 * 遵循安全扫描规范与 CWE-601 防御方案：
 * 1. 允许站内相对路径（以 / 开头且不以 // 开头，或以 # 开头的路由）
 * 2. 校验协议安全性（仅允许 http: 和 https:，拦截 javascript:、data: 等伪协议）
 * 3. 校验域名白名单（仅允许 meituan.com、sankuai.com 及其子域名）
 * @param {string} url 目标跳转地址
 * @returns {boolean} 是否安全可跳转
 */
export function isSafeRedirect(url) {
	if (!url || typeof url !== 'string') {
		return false;
	}
	const trimmedUrl = url.trim();
	if (!trimmedUrl) {
		return false;
	}

	// 1. 站内相对路径：以 / 开头且不以 // 开头（防止协议相对 URL 如 //evil.com），或者以 # 开头的 hash 路由
	if ((trimmedUrl.startsWith('/') && !trimmedUrl.startsWith('//')) || trimmedUrl.startsWith('#')) {
		return true;
	}

	// 2. 解析 URL 并校验协议及域名白名单
	try {
		const parsed = new URL(trimmedUrl, window.location.origin);
		// 拦截 javascript:、data:、vbscript: 等危险伪协议
		if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') {
			return false;
		}

		const hostname = parsed.hostname.toLowerCase();
		// 校验是否属于白名单域名或其子域名（例如 km.sankuai.com, passport.meituan.com）
		return ALLOWED_DOMAINS.some(domain => {
			const d = domain.toLowerCase();
			return hostname === d || hostname.endsWith('.' + d);
		});
	} catch (e) {
		return false;
	}
}
